export const dropdownSchema = {
	schema: {
		title: 'dropdown schema',
		description: 'Dropdown Schema',
		version: 0,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			name: {
				type: 'string',
			},
			expiry_date: {
				type: 'string',
			},
		},
		required: ['id', 'name'],
	},
};
